//import { axios } from '@/api';
import Axios from 'axios';
import store from '@/store'
import http from "../..";
import router from '@/router'


class AjusteServices {
  
  

  consultarConteoExpress(params) {  
    return http.get("/inventario/conteo/consultarConteoExpress", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 
  

  conteoActualizar(data) {
    return http.post("/inventario/conteo/conteoActualizar", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }

  AjusteActualizar(data) {
    return http.post("/inventario/ajuste/ajusteActualizar", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }


  ajusteListarPaginado(params) {  
    return http.get("/inventario/ajuste/ajusteListarPaginado", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 
  conteoListarPaginado(params) {  
    return http.get("/inventario/ajuste/conteoListarPaginado", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  } 
  
  
  listarMotivoAjuste(params) {  
    return http.get("/inventario/ajuste/listarMotivoAjuste", { params })
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }  


  anularAjuste(data) {
    return http.post("/inventario/ajuste/ajusteAnular", data)
    .catch((error) => { 
      if (error.response.status == 403) {
        store.commit("setUserData", { id: 0, userName: "", IsAutenticated: false });
        router.push('/pages/login').catch(error => {
        if (error.name != 'NavigationDuplicated') {
          throw error
        }
      });
      } 
    });
  }
 

   
}

export default new AjusteServices();